/* screens/academy/landing/CoursePreviewPage.jsx — маршрут /academy/course/:id/preview (#16).
   Предпросмотр лендинга из ЧЕРНОВИКА (manage-данные) для методиста — отдельная
   standalone-страница (БЕЗ оболочки AppShell), открывается в новой вкладке из
   редактора курса. Гард доступа — RequireAcademyAccess (объявлен в routes.jsx).
   CTA показываются, но ИНЕРТНЫ (mode='preview' в CourseLanding) + баннер «Предпросмотр».
   Данные — getLandingPreview(id) (manage; черновик landing_json + публичные поля курса). */

import React from 'react';
import { Button } from '../../../components/ui/Button.jsx';
import { Icon } from '../../../components/ui/Icon.jsx';
import { Spinner } from '../../../components/ui/Spinner.jsx';
import { hooks } from '../../../hooks/index.jsx';
import { RR } from '../../../lib/router.jsx';
import * as api from '../../../lib/api/academy.js';
import { CourseLanding } from './CourseLanding.jsx';

const { useFakeQuery } = hooks;
const { useParams, useNavigate } = RR;

function CoursePreviewPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const q = useFakeQuery('landing-preview-' + id, () => api.getLandingPreview(id), [id]);

  return (
    <div className="cl-standalone cl-standalone--preview">
      <header className="cl-topbar">
        <Button variant="ghost" size="sm" iconLeft="arrow-left"
          onClick={() => (window.history.length > 1 ? navigate(-1) : window.close())}>
          Назад
        </Button>
        <span className="cl-topbar__spacer" />
        <span className="cl-topbar__brand">
          <img src="/logo-mark.svg" alt="" width={22} height={22} />Ресториум
        </span>
        <span className="cl-topbar__spacer" />
      </header>

      <main className="cl-standalone__main">
        {q.loading && !q.data && (
          <div className="cl-state"><Spinner size="lg" /><div className="t-label">Загружаем предпросмотр…</div></div>
        )}
        {!q.loading && (q.error || !q.data) && (
          <div className="cl-state">
            <div className="cl-state__glyph"><Icon name="alert-circle" size={24} /></div>
            <h2 className="t-h2">Не удалось открыть предпросмотр</h2>
            <p className="text-dim">Откройте страницу из редактора курса ещё раз.</p>
            <Button variant="secondary" onClick={q.reload}>Повторить</Button>
          </div>
        )}
        {q.data && <CourseLanding payload={q.data} mode="preview" />}
      </main>
    </div>
  );
}

export { CoursePreviewPage };
